import type { RTKParticipant } from "@cloudflare/realtimekit";
import { getVideoGridLayout } from "./livestreamStageFeeds";
import { RTK_HOST_PRESET } from "./realtimeKitPresets";
import { LivestreamParticipantVideo } from "./LivestreamParticipantVideo";

export function LivestreamVideoGrid({
  participants,
  selfId,
  waitingLabel = "Waiting for host…",
  hostPipDraggable = false,
}: {
  participants: RTKParticipant[];
  selfId: string;
  waitingLabel?: string;
  hostPipDraggable?: boolean;
}) {
  if (participants.length === 0) {
    return (
      <div className="flex h-full w-full items-center justify-center text-white">
        {waitingLabel}
      </div>
    );
  }

  if (participants.length === 1) {
    const participant = participants[0]!;
    return (
      <LivestreamParticipantVideo
        participant={participant}
        muted={participant.id === selfId}
        fill
        className="h-full w-full"
        pipDraggable={
          hostPipDraggable && participant.presetName === RTK_HOST_PRESET
        }
      />
    );
  }

  const { cols, rows } = getVideoGridLayout({ count: participants.length });

  return (
    <div
      className="grid h-full w-full gap-1"
      style={{
        gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
        gridTemplateRows: `repeat(${rows}, minmax(0, 1fr))`,
      }}
    >
      {participants.map((participant) => (
        <LivestreamParticipantVideo
          key={participant.id}
          participant={participant}
          muted={participant.id === selfId}
          className="min-h-0 min-w-0"
          pipDraggable={
            hostPipDraggable && participant.presetName === RTK_HOST_PRESET
          }
        />
      ))}
    </div>
  );
}
